import { defineStore } from 'pinia';
import {
  readPersistedStoreState,
  writePersistedStoreState,
} from '@/stores/persistence/pinia-indexeddb';

export type ShipmentsViewMode = 'table' | 'map';

function isShipmentsViewMode(value: unknown): value is ShipmentsViewMode {
  return value === 'table' || value === 'map';
}

export const useShipmentsViewModeStore = defineStore('shipmentsViewMode', {
  state: () => ({
    viewMode: 'table' as ShipmentsViewMode,
    persistenceHydrated: false,
  }),
  actions: {
    async hydrateFromBrowserDb() {
      if (this.persistenceHydrated) {
        return;
      }
      try {
        const payload = await readPersistedStoreState<{
          viewMode?: unknown;
        }>(this.$id);
        if (isShipmentsViewMode(payload?.viewMode)) {
          this.viewMode = payload.viewMode;
        }
      } catch {
        // IndexedDB unavailable — keep default viewMode
      } finally {
        this.persistenceHydrated = true;
      }
    },
    persistToBrowserDb() {
      void writePersistedStoreState(this.$id, {
        viewMode: this.viewMode,
      });
    },
    setViewMode(mode: ShipmentsViewMode) {
      if (mode !== 'table' && mode !== 'map') {
        return;
      }
      this.viewMode = mode;
      this.persistToBrowserDb();
    },
  },
});
